import Select from "./Select";
import "../../styles/common/forms.css";
import checkbox_tick from "../../assets/icons/checkbox_tick.svg";

const FormInput = ({
  type = "text",
  label,
  placeholder,
  value,
  setValue,
  options,
  optional = false,
}) => {
  if (type === "select") {
    return (
      <div className={`form-input ${optional ? "optional" : ""}`}>
        <label>{label}</label>
        <Select
          placeholder={placeholder}
          options={options}
          value={value}
          setValue={setValue}
          fullWidth
        />
      </div>
    );
  }

  if (type === "textarea") {
    return (
      <div className={`form-input ${optional ? "optional" : ""}`}>
        <label>{label}</label>
        <textarea
          placeholder={placeholder}
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      </div>
    );
  }

  if (type === "checkbox") {
    return (
      <div className={`form-input row ${optional ? "optional" : ""}`}>
        <div
          className="checkbox flex-jcc-aic"
          onClick={() => setValue((prev) => !prev)}
        >
          {value && <img src={checkbox_tick} alt="tick" />}
        </div>
        <label>{label}</label>
      </div>
    );
  }

  return (
    <div className={`form-input ${optional ? "optional" : ""}`}>
      <label>{label}</label>
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    </div>
  );
};

export default FormInput;
